import { Box, Button, Group, Menu, Text } from '@mantine/core';
import { IconChevronDown, IconUser } from '@tabler/icons-react';
import type { IconProps } from '@tabler/icons-react';
import React, { useState, ComponentType } from 'react';
import { useNavigate } from 'react-router-dom';
import { LEFT_COLUMN_ITEMS, LOGOUT_ITEM } from '../constants/navigation';
import { useAuth } from '../hooks/useAuth';

// Reusable components
interface IconContainerProps {
	children: React.ReactNode;
}

function IconContainer({ children }: IconContainerProps) {
	return (
		<Box
			style={{
				backgroundColor: 'var(--mantine-color-gray-0)',
				border: '1px solid var(--mantine-color-gray-1)',
				borderRadius: '4px',
				padding: '6px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			{children}
		</Box>
	);
}

interface MenuItemProps {
	icon: ComponentType<IconProps>;
	label: string;
	description: string;
	onClick: () => void;
}

function MenuItem({ icon: IconComponent, label, description, onClick }: MenuItemProps) {
	const [isHovered, setIsHovered] = useState(false);

	return (
		<Box
			p="xs"
			h={60}
			style={{
				cursor: 'pointer',
				transition: 'background-color 0.2s ease',
				borderRadius: '4px',
				backgroundColor: isHovered ? 'var(--mantine-color-gray-0)' : 'transparent',
			}}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			onClick={onClick}
		>
			<Group align="flex-start">
				<IconContainer>
					<IconComponent size={16} />
				</IconContainer>
				<Box style={{ flex: 1 }}>
					<Text>{label}</Text>
					<Text size="xs" c="dimmed">
						{description}
					</Text>
				</Box>
			</Group>
		</Box>
	);
}

export function HeaderNavigation() {
	const navigate = useNavigate();
	const { user, logout } = useAuth();
	const [menuOpened, setMenuOpened] = useState(false);

	const handleMenuItemClick = (path: string) => {
		navigate(path);
		setMenuOpened(false);
	};

	const handleLogout = () => {
		setMenuOpened(false);
		logout();
	};

	return (
		<Group gap="sm">
			{/* User Menu */}
			<Menu width={320} opened={menuOpened} onChange={setMenuOpened}>
				<Menu.Target>
					<Button
						size="xs"
						variant="subtle"
						color="gray"
						rightSection={<IconChevronDown size={12} />}
						leftSection={<IconUser size={12} />}
					>
						Hi, {user?.email?.split('@')[0] || 'Jane'}
					</Button>
				</Menu.Target>

				<Menu.Dropdown p="lg" style={{ minWidth: '350px' }}>
					<Box>
						{/* Log out */}
						<Box
							p="xs"
							style={{
								cursor: 'pointer',
								transition: 'background-color 0.2s ease',
								borderRadius: '4px',
							}}
							onMouseEnter={(e) => {
								e.currentTarget.style.backgroundColor =
									'var(--mantine-color-gray-0)';
							}}
							onMouseLeave={(e) => {
								e.currentTarget.style.backgroundColor = 'transparent';
							}}
							onClick={handleLogout}
						>
							<Group align="center">
								<IconContainer>
									<LOGOUT_ITEM.icon size={16} />
								</IconContainer>
								<Box style={{ flex: 1 }}>
									<Text>{LOGOUT_ITEM.label}</Text>
								</Box>
							</Group>
						</Box>
					</Box>
				</Menu.Dropdown>
			</Menu>
		</Group>
	);
}
